'use client'

import {createContext, FC, PropsWithChildren} from 'react'

import {Prices, PricesV2} from '@/utils/pricing'
import {injectPrices, injectPricesV2} from '@/utils/pricing/prices'
import {pricesEmpty} from '@/utils/pricing/pricesEmpty'

type PricesContextType = {
  prices: Prices
  pricesV2?: PricesV2
}

/**
 * `null` means the surrounding page is prerendered — there were no prices to resolve at build
 * time, so the cache stays empty until the first per-request page supplies them.
 */
type PricesProviderProps = {
  prices: Prices | null
  pricesV2?: PricesV2
}

const PricesContext = createContext<PricesContextType>({
  prices: pricesEmpty,
})

export const PricesProvider: FC<PropsWithChildren<PricesProviderProps>> = ({
  prices,
  pricesV2,
  children,
}) => {
  injectPrices(prices)
  injectPricesV2(pricesV2)
  return (
    <PricesContext.Provider value={{prices: prices ?? pricesEmpty}}>
      {children}
    </PricesContext.Provider>
  )
}
